

























import { Vue, Component, Mixins, Prop, Watch } from "vue-property-decorator";

import _ from "lodash";

@Component
export default class extends Mixins() {
  @Prop() value!: any;

  @Prop() mode!: string;

  @Prop({ default: true }) allowClear!: boolean;

  value1: any = null;

  searchvalue: string = "";

  data: any[] = [];

  isMounted = false;

  @Watch("value")
  watchValue(val: any, oldVal: any) {
    if (val) {
      if (Array.isArray(val)) {
        this.value1 = val;
        this.fetch1(this.value1);
      } else {
        this.value1 = String(val);
        this.fetch(this.value1);
      }
    } else {
      this.value1 = null;
    }
  }

  fetch(value: any) {
    this.$store
      .dispatch("api/getUsers", {
        keyword: value
      })
      .then((res: any) => {
        if (res && res.Data) {
          this.data = res.Data;
        } else {
          this.data = [];
        }
      });
  }

  fetch1(userIds: any) {
    if (!_.isArray(userIds)) {
      userIds = [userIds];
    }
    this.$store
      .dispatch("api/getUsers", {
        user_ids: userIds
      })
      .then((res: any) => {
        if (res && res.Data) {
          this.data = res.Data;
        } else {
          this.data = [];
        }
      });
  }

  handleSearch(value: string) {
    this.searchvalue = value;
    // this.fetch(value);
    this.debouncedFetch();
  }

  handleChange(value: string) {
    // console.log(value)
    this.value1 = value;
    this.$emit("change", value);
    this.fetch(value);
  }

  debouncedFetch: any;

  created() {
    this.debouncedFetch = _.debounce(() => this.fetch(this.searchvalue), 500);
  }

  unmounted() {
    this.debouncedFetch.cancel();
  }

  mounted() {
    const query = { ...this.$route.query };

    let { value } = this;

    if (query.user_id) {
      value = query.user_id;
    }

    if (value) {
      if (value || value.length > 0) {
        this.value1 = value;
        if (!_.isArray(this.value1)) {
          this.value1 = this.value1.toString();
        }
        this.fetch1(this.value1);
      }
    }
  }
}
